// AV Library messages used within the cohort builder.
export const analyticalVariableLibraryMessagesEn = {
  'projects.analyticalVariables.library.editPageBanner':
    'Your changes will create a new variable for this cohort only. The original variable will remain unchanged in the library.',
  // Publish to Library dialog
  'projects.analyticalVariables.library.publishDialog.title': 'Publish variable',
  'projects.analyticalVariables.library.publishDialog.variableNameLabel': 'Variable name',
  'projects.analyticalVariables.library.publishDialog.variableNamePlaceholder':
    'Enter a variable name',
  'projects.analyticalVariables.library.publishDialog.infoText':
    "Once published, this variable will be available to all users of your organization in any project. Changes made within a cohort will make a copy and won't change the published version.",
  'projects.analyticalVariables.library.publishDialog.publish': 'Publish',
  'projects.analyticalVariables.library.publishDialog.publishing': 'Publishing...',
  'projects.analyticalVariables.library.publishDialog.nameConflictError':
    'A variable with this name already exists in the library. Please choose a different name.',
  'projects.analyticalVariables.library.publishDialog.nameCheckError':
    'Unable to check name availability. Please try again.',
  'projects.analyticalVariables.library.publishDialog.close': 'Close',
  'projects.analyticalVariables.library.publishDialog.retry': 'Try again',
  'projects.analyticalVariables.library.publishDialog.successTitle':
    'Analytical variable published to library',
  'projects.analyticalVariables.library.publishDialog.successText':
    'This variable is now available in the library and can be added to any cohort in your project.',
  'projects.analyticalVariables.library.publishDialog.errorTitle': 'Failed to publish to library',
  'projects.analyticalVariables.library.publishDialog.errorText': 'Please try again.',
  'projects.analyticalVariables.library.cancel': 'Cancel',
  'projects.analyticalVariables.library.setIndexDate.label': 'Set index date',
  // The available-variable count sits in the subheading (e.g. "Select a variable (12)").
  'projects.analyticalVariables.library.selectVariableWithCount': 'Select a variable ({count})',
  // Bulk-selection toggle shown beside the subheading in multi-select mode.
  'projects.analyticalVariables.library.selectAll': 'Select all',
  'projects.analyticalVariables.library.clearAll': 'Clear all',
  'projects.analyticalVariables.library.searchPlaceholder': 'Search variables',
  'projects.analyticalVariables.library.loadingError': 'Failed to load library variables.',
  'projects.analyticalVariables.library.noResults': 'No variables match your search.',
  'projects.analyticalVariables.library.unknown': 'Unknown',
  // Set index date modal
  'projects.analyticalVariables.library.setIndexDate.tabVariable': 'Variable based',
  'projects.analyticalVariables.library.setIndexDate.tabCalendar': 'Fixed index date',
  'projects.analyticalVariables.library.setIndexDate.variableDescription':
    'Select a variable to use as the index date. Only clinical variables with boolean format and without time window references to index date are eligible.',
  'projects.analyticalVariables.library.setIndexDate.occurrenceLabel':
    'Occurrence to use as index date',
  'projects.analyticalVariables.library.setIndexDate.occurrenceFirst': 'First occurrence',
  'projects.analyticalVariables.library.setIndexDate.occurrenceNth': 'Nth occurrence:',
  'projects.analyticalVariables.library.setIndexDate.occurrenceLast': 'Last occurrence',
  'projects.analyticalVariables.library.setIndexDate.calendarDescription':
    'Set a fixed calendar date as the index date for all patients in the cohort.',
  'projects.analyticalVariables.library.setIndexDate.calendarLabel': 'Index date',
  'projects.analyticalVariables.library.setIndexDate.noEligible':
    'No eligible variables found in the library.',
  'projects.analyticalVariables.library.setIndexDate.addError':
    'Failed to set index date. Please try again.',
  // Add variable from library modal
  'projects.analyticalVariables.library.addFromLibrary.buttonLabel': 'Add criterion',
  'projects.analyticalVariables.library.addFromLibrary.modalTitle': 'Add variable from library',
  'projects.analyticalVariables.library.addFromLibrary.roleLabel': 'Role in cohort',
  'projects.analyticalVariables.library.addFromLibrary.nameConflictChip':
    "A variable named ''{name}'' already exists in this cohort. Rename the existing variable before adding this one.",
  'projects.analyticalVariables.library.ineligible.nonBooleanCriterion':
    "Output format is ''{format}''. With 'All other criteria met', criteria must be boolean variables.",
  'projects.analyticalVariables.library.ineligible.missingIndexDateColumn':
    "Depends on the index date but was built without an index date column. Regenerate it to use it with 'All other criteria met'.",
  'projects.analyticalVariables.library.addFromLibrary.formatOwner':
    'Format: {format} · Owner: {owner}',
  'projects.analyticalVariables.library.addFromLibrary.addVariables':
    '{count, plural, one {Add variable} other {Add variables}}',
  'projects.analyticalVariables.library.addFromLibrary.roleInclusion': 'Inclusion',
  'projects.analyticalVariables.library.addFromLibrary.roleExclusion': 'Exclusion',
  'projects.analyticalVariables.library.addFromLibrary.emptyLibrary':
    'No variables in the library yet.',
  'projects.analyticalVariables.library.addFromLibrary.addError':
    'Failed to add variable. Please try again.',
};
